import Swal from '@global/config/defaultSwal';

export function showBlockingAlert(
  title: string | HTMLElement,
  html: string | HTMLElement,
  footer: string | HTMLElement = null,
) {
  return Swal.fire({
    title,
    icon: 'info',
    iconHtml: null,
    html: `
      <div style="font-size: 12px"> ${html} </div>
    `,
    footer,
    showCancelButton: false,
    showConfirmButton: false,
    focusConfirm: false,
    focusCancel: false,
    reverseButtons: false,
  });
}
